import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import { PageEventFragment } from 'types/api/dato-operations.types';

import FormattedDateTime from 'components/@events/FormattedDateTime';

interface Props {
  event: PageEventFragment;
  gradientCover?: boolean;
  sx?: SxProps<Theme>;
}

const EventHeader = ({ event, gradientCover, sx }: Props) => {
  return (
    <Box
      sx={[
        {
          mt: { xs: gradientCover ? -3 : 0, md: 0 },
          gridArea: 'header',
          position: 'relative',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          mb: { xs: 0.5, md: 1 },
        }}
      >
        {event.title}
      </Typography>
      <FormattedDateTime
        endDatetime={event.endDatetime}
        startDatetime={event.startDatetime}
        timezone={event.timezone}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          mt: 1,
        }}
      >
        <Chip label={event.venue.name} size="small" />
        <Chip label={event.venue.city.name} size="small" />
      </Box>
    </Box>
  );
};

export default EventHeader;
